<div class="welldone-card">
    <div class="welldone-card-header">
        Movimento di magazzino
    </div>
    <div class="welldone-card-body">
        <form #athleteDocumentEditForm="ngForm" class="w-100">

            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-4">
                        <label class="form-label required">Quantità</label>
                        <input type="number" class="form-control form-control-solid"
                               [(ngModel)]="barcodeMovement.amount" name="barcode" required min="1"/>
                    </div>
                    <div class="col-6">
                        <label class="form-label required">Quantità</label>
                        <select class="form form-control" [(ngModel)]="movementType"
                                [ngModelOptions]="{standalone: true}">
                            <option value="load" selected>Carico</option>
                            <option value="unload">Scarico</option>
                        </select>
                    </div>

                </div>
            </div>
        </form>
    </div>
    <div class="welldone-card-footer">
        <div class="d-flex justify-content-end">
            <button class="btn btn-primary" *ngIf="editPage; else addPageBtn"
                    [disabled]="!athleteDocumentEditForm.valid"
                    (click)="editBarcode()">
                Modifica
            </button>
            <ng-template #addPageBtn>
                <button class="btn btn-primary"
                        [disabled]="!athleteDocumentEditForm.valid"
                        (click)="addBarcode()"> Crea
                </button>
            </ng-template>
        </div>
    </div>
</div>
